import { CategoryItemType } from '../types'

export interface ReactFeaturedCategoryListProps {
  heading?: string
  subheading?: string
  categoryitems?: Array<CategoryItemType>
  icon?: string
  altIcon?: string
  listType?: FCLIstType
  variation?: string | number
  top?: boolean
  right?: boolean
  bottom?: boolean
  left?: boolean
  id?: string
  isInEditor?: boolean
  tokenProperties?: string
}

export enum FCLIstType {
  WITH_ICON = 'withIcon',
  WITH_OUT_ICON = 'withOutIcon'
}

export enum FCListBgVariations {
  BLUE_BACKGROUND = 'blueBackground',
  WHITE_BACKGROUND = 'whiteBackground'
}
